// components/modals/MeetingEventDetailModal.js
// (Formerly TranscriptDetailModal.js)

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { FiLoader, FiXCircle, FiCheckCircle, FiList, FiTarget, FiUsers, FiClock, FiX, FiRefreshCw } from 'react-icons/fi';
import { CheckCircle, XCircle, User, Calendar, Tag, Briefcase, FileText, AlertTriangle, DollarSign, ArrowRight, Link as LinkIcon, AtSign, ThumbsUp, ThumbsDown, GitBranch, X as XIcon, Braces, Brackets, Send, Users, Hourglass, Check, Clipboard, ListChecks, RefreshCw, FileX, AlertCircle, Loader2, Info, ChevronsRight, CheckSquare, AlertOctagon, ArrowRightCircle, Target, GitCommit, UserCheck, GitPullRequest, Paperclip, ChevronDown, ChevronRight, MessageSquare, Zap } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import toast from 'react-hot-toast';
import {ProcessedContent} from "../meeting/ProcessedMeetingContent"
const modalRoot = document.getElementById('modal-root');

// Helper to format the meeting date and time
const formatTranscriptDateTime = (eventDate, meetingTime) => {
    const date = new Date(eventDate);
    const time = new Date(meetingTime);

    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        time.getHours(),
        time.getMinutes()
    ).toLocaleString(undefined, {
        dateStyle: 'full',
        timeStyle: 'short'
    });
};

const LoadingState = ({ text }) => (
    <div className="flex flex-col items-center justify-center p-8 text-center text-slate-400">
        <FiLoader className="h-8 w-8 animate-spin mb-4 text-blue-400" />
        <p className="font-semibold">{text}</p>
        <p className="text-xs text-slate-500">This may take a moment...</p>
    </div>
);

const FailedState = () => (
    <div className="flex flex-col items-center justify-center p-8 text-center text-red-400">
        <FiXCircle className="h-8 w-8 mb-4" />
        <p className="font-semibold">Processing Failed</p>
        <p className="text-xs text-slate-500">There was an error while processing this event.</p>
    </div>
);


const MeetingEventDetailModal = ({ isOpen, onClose, meeting, meetingEvent }) => {

    useEffect(() => {
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
        return () => document.body.style.overflow = 'unset';
    }, [isOpen]);

    if (!isOpen || !meetingEvent) return null;

    const renderContent = () => {
        switch (meetingEvent.status) {
            case 'pending':
                return <LoadingState text="Event is pending processing. Click the 'Process' button." />;
            case 'queued': // +++ ADDED
                return <LoadingState text="Event is queued for processing..." />;
            case 'processing':
                return <LoadingState text="Processing event..." />;
            case 'reprocessing':
                return <LoadingState text="Reprocessing event with new transcripts..." />;
            case 'failed':
                return <FailedState />;
            case 'processed':
                return meetingEvent.llm_summary ? (
                    <ProcessedContent data={meetingEvent.llm_summary} />
                ) : (
                    <div className="p-8 text-center text-slate-500">
                        <p>Processed, but no summary data is available.</p>
                    </div>
                );
            default:
                return <div className="p-8 text-center text-slate-500">Unknown event status.</div>;
        }
    };

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm z-[60] flex justify-center items-center p-4"
            onClick={onClose}
        >
            <div
                className="bg-zinc-900 text-p-text rounded-2xl shadow-xl relative flex flex-col w-full max-h-[90vh] max-w-3xl"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex justify-between items-center p-4 md:p-6 border-b border-slate-700">
                    <h3 className="text-xl font-semibold text-white">{meeting.title}</h3>
                    <button onClick={onClose} className="p-1 rounded-full text-gray-400 hover:bg-slate-700 hover:text-white">
                        <FiX size={24} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-4 md:p-6 overflow-y-auto">
                    <div className="mb-4 p-3 bg-slate-800 rounded-lg border border-slate-700">
                        <h3 className="text-lg font-semibold text-white">{meeting.title}</h3>
                        <p className="text-sm text-blue-300">
                            {formatTranscriptDateTime(meetingEvent.date, meeting.startTime)}
                        </p>
                        <p className="text-xs text-slate-400 mt-1">Status: {meetingEvent.status}</p>
                    </div>
                    {renderContent()}
                </div>
            </div>
        </div>,
        modalRoot
    );
};

export default MeetingEventDetailModal;